import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import "./responsive.css";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import HomeScreen       from "./screens/HomeScreen";
import SingleProduct    from "./screens/SingleProduct";
import Login            from "./screens/Login";
import Register         from "./screens/Register";
import CartScreen       from "./screens/CartScreen";
import ShippingScreen   from "./screens/ShippingScreen";
import ProfileScreen    from "./screens/ProfileScreen";
import PaymentScreen    from "./screens/PaymentScreen";
import PlaceOrderScreen from "./screens/PlaceOrderScreen";
import OrderScreen      from "./screens/OrderScreen";
import NotFound         from "./screens/NotFound";
import PrivateRoutes    from "./PrivateRoutes";
import ShopSection      from "./components/homeComponents/ShopSection";
import ProductPage      from "./components/homeComponents/ProductPage";

import ReactGA    from "react-ga4";
import AutoLogout from "../src/components/AutoLogOut";
import webSocketClient from "./screens/WebSocket";

if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("G-BSNFH26GSZ", {
    gaOptions: { send_page_view: false },
  });
}

const AppRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <AutoLogout>
      <Routes>
        {/* Public routes */}
        <Route path="/"                                      element={<HomeScreen />} />
        <Route path="/search/:keyword"                       element={<HomeScreen />} />
        <Route path="/page/:pageNumber"                      element={<HomeScreen />} />
        <Route path="/search/:keyword/page/:pageNumber"      element={<HomeScreen />} />
        <Route path="/product/:id"                           element={<ProductPage />} />
        <Route path="/products/:id"                          element={<SingleProduct />} />
        <Route path="/login"                                 element={<Login />} />
        <Route path="/register"                              element={<Register />} />
        <Route path="/cart/:id?"                             element={<CartScreen />} />

        {/* ShopSection */}
        <Route path="/search/:keyword"                       element={<ShopSection />} />
        <Route path="/page/:pageNumber"                      element={<ShopSection />} />
        <Route path="/search/:keyword/page/:pageNumber"      element={<ShopSection />} />

        {/* Protected routes — logged-in users only */}
        <Route element={<PrivateRoutes />}>
          <Route path="/profile"    element={<ProfileScreen />} />
          <Route path="/shipping"   element={<ShippingScreen />} />
          <Route path="/payment"    element={<PaymentScreen />} />
          <Route path="/placeorder" element={<PlaceOrderScreen />} />
        </Route>

        {/* Order screen — public route, auth handled per-request via JWT */}
        <Route path="/order/:id" element={<OrderScreen />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AutoLogout>
  );
};

const App = () => {
  useEffect(() => {
    webSocketClient.connect();
    webSocketClient.onMessage((msg) => {
      console.log("📬 WebSocket message received in App:", msg);
    });
    return () => webSocketClient.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="app">
        <Router future={{ v7_startTransition: true }}>
          <AppRoutes />
        </Router>
      </div>
    </HelmetProvider>
  );
};

export default App;